import type { PropsWithChildren } from 'react'

import styled from 'styled-components'

type ModuleCardBodyProps = PropsWithChildren<unknown>

const Container = styled.div`
  aspect-ratio: 16/9;
  @supports not (aspect-ratio: 16/9) {
    &:before {
      float: left;
      padding-top: 56.25%;
      content: '';
    }
    &:after {
      display: block;
      content: '';
      clear: both;
    }
  }
`

const Box = styled.div`
  transition: all 0.3s ease;
  opacity: 1;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transition: opacity var(--timing) var(--easing) calc(var(--timing) / 2),
    top var(--timing) var(--easing), right var(--timing) var(--easing),
    bottom var(--timing) var(--easing), left var(--timing) var(--easing),
    box-shadow var(--timing) var(--easing);

  @supports not (aspect-ratio: 16/9) {
    &:before {
      float: left;
      padding-top: 56.25%;
      content: '';
    }

    &:after {
      display: block;
      content: '';
      clear: both;
    }
  }
`

const ModuleCardBody = ({ children }: ModuleCardBodyProps) => {
  return (
    <Container className='_position-relative'>
      <Box className='module-card-body _position-absolute _d-flex _flex-direction_column _align-items-center _justify-content-center _overflow-hidden _bg-gray-200 _rounded-lg'>
        {children}
      </Box>
    </Container>
  )
}

export default ModuleCardBody
